import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_access_to_high_voltage_areas_and_generator_areas_restricted'

export const dataPointDefinition = {
  retracedId: 'is_access_to_high_voltage_areas_and_generator_areas_restricted',
  name: 'Is access to high voltage areas and generator areas restricted to authorized personnel only?',
  description: 'If the facility does not have high voltage areas/ generator areas, answer Not Applicable.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-43',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16620,
  sectionId: '2.2.9.9',
  impactArea: 'Electrical Safety',
  impactAreaId: 'ELECTRICAL_SAFETY',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
